/** Curated company timezones: `id` = IANA value saved to API, `text` = UI label. */
export const TIMEZONE_OPTIONS = [
  { id: "Africa/Nairobi", text: "Africa/Nairobi (EAT)" },
  { id: "Africa/Kampala", text: "Africa/Kampala (EAT)" },
  { id: "Africa/Dar_es_Salaam", text: "Africa/Dar es Salaam (EAT)" },
  { id: "Africa/Kigali", text: "Africa/Kigali (CAT)" },
  { id: "Africa/Johannesburg", text: "Africa/Johannesburg (SAST)" },
  { id: "Europe/London", text: "Europe/London (GMT/BST)" },
  { id: "UTC", text: "UTC" },
  { id: "America/New_York", text: "America/New_York (ET)" },
  { id: "Asia/Dubai", text: "Asia/Dubai (GST)" },
];

/** Default IANA timezone when a country is selected (2-letter code). */
export const COUNTRY_DEFAULT_TIMEZONE = {
  KE: "Africa/Nairobi",
  UG: "Africa/Kampala",
  TZ: "Africa/Dar_es_Salaam",
  RW: "Africa/Kigali",
};

/**
 * Normalize legacy stored values like "Africa/Nairobi (EAT)" to "Africa/Nairobi".
 * Returns empty string when input is empty.
 */
export function normalizeTimezoneValue(raw) {
  if (!raw) return "";
  const trimmed = String(raw).trim();

  const fromOptions = TIMEZONE_OPTIONS.find(
    (opt) => opt.id === trimmed || opt.text === trimmed
  );
  if (fromOptions) return fromOptions.id;

  const withoutLabel = trimmed.replace(/\s*\([^)]*\)\s*$/, "").trim();
  if (TIMEZONE_OPTIONS.some((opt) => opt.id === withoutLabel)) {
    return withoutLabel;
  }

  return withoutLabel || trimmed;
}
